<template>

    <div>
        <!-- <el-form :inline="true" :model="query" class="query-form">
            <el-form-item>
                <el-input v-model="query.name" placeholder="发布人名称"></el-input>
            </el-form-item>
            <el-form-item class="query-form-item" label="时间：" size="mini">
                <span class="demonstration"></span>
                <el-date-picker
                    v-model="query.start_time"
                    type="date"
                    placeholder="开始时间"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
                -
                <el-date-picker
                    v-model="query.end_time"
                    type="date"
                    placeholder="结束时间"
                    value-format="yyyy-MM-dd 23:59:59"
                    format="yyyy-MM-dd 23:59:59">
                </el-date-picker>
            </el-form-item>

            <el-form-item>
                <el-button-group>
                    <el-button type="primary"  icon="el-icon-search" @click.native="onSubmit(1)">查询</el-button>
                    <el-button type="primary"  icon="el-icon-refresh" @click="onSubmit(2)">重置</el-button>
                </el-button-group>
            </el-form-item>
        </el-form> -->
        <el-table
            @click="dow(scope.row.cate_id)"
            text-align="center"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
            v-loading="loading"
            ref="multipleTable"
            :data="datass"
            style="width: 100%;"
            :header-cell-style="{background:'#F4F4F5',color:'#606266'}">
            <!-- <el-table-column type="selection" width="55" fixed> </el-table-column> -->
            <!-- <el-table-column
                label="封面"
                prop="image"
                fixed>
                <template slot-scope="scope">            
                    <img :src="scope.row.image"  min-width="70" height="70" />
                </template> 
            </el-table-column> -->
            <el-table-column align="center" label="观点ID" prop="id"> </el-table-column>
            <el-table-column align="center" label="昵称" >
                 <template  slot-scope="scope" >
                     <span v-if="scope.row.is_anonymous == 1">{{ scope.row.nick }}<span  style="color:rgb(236, 150, 45)">(匿名)</span></span>
                     <span v-else-if="scope.row.is_examine == 1"> {{ scope.row.nick }} <span  style="color:rgb(236, 150, 45)">(未审核)</span></span>
                     <span v-else> {{ scope.row.nick }}</span>
                </template>

<!-- 
                <template  slot-scope="scope">
                    {{ scope.row.nick }}

                    <span v-if="scope.row.is_anonymous == 1" style="color:rgb(236, 150, 45)">(匿名)</span>
                    
                    
                </template> -->
            </el-table-column>
            <el-table-column
                label="头像"
                prop="image"
                align="center"
                >
                <template slot-scope="scope">            
                    <img :src="scope.row.image"  min-width="80" height="80" />
                </template> 
            </el-table-column>

            <!-- <el-table-column align="center" label="头像">
                
                <template  slot-scope="scope" >
                     <img src="scope.row.image" />
                </template>
            </el-table-column> -->
            <el-table-column align="center" label="简介" prop="autograph"></el-table-column>
            <el-table-column align="center" label="观点内容" prop="content"></el-table-column>
            <el-table-column align="center" label="评论时间" prop="create_time"></el-table-column>
            <!-- <el-table-column align="center" label="top" prop="is_top">
                <template  slot-scope="scope" >
                     <span >{{ scope.row.is_top | topStatus}}</span>
                </template>
            </el-table-column> -->
            <el-table-column
                align="center"
                label="审核"
                fixed="right">
                <template  slot-scope="scope" >
                    <span v-if="scope.row.is_anonymous == 1" >
                        <el-button type="text" style="color:gray" size="small" @click.native="Examine(scope.row.from_uid,2)" ><span :class="scope.row.is_examine===2?'activeColor':''">用户放行</span></el-button>
                        <el-button type="text" style="color:gray" size="small" @click.native="Examine(scope.row.from_uid,3)" ><span :class="scope.row.is_examine===3?'activeColor':''">审核不通过</span></el-button>
                    </span>
                    <span v-if="scope.row.is_anonymous == 2">
                        <el-button type="text" style="color:gray" size="small" @click.native="ConnectExamine(scope.row.id,scope.row.is_release,scope.row.is_release,'is_release')" ><span :class="scope.row.is_release===1?'activeColor':''">放行</span></el-button>
                        <el-button type="text" style="color:gray" size="small" @click.native="ConnectExamine(scope.row.id,scope.row.is_release,scope.row.is_top,'is_top')"  ><span :class="scope.row.is_top===1?'activeColor':''">置顶</span></el-button>
                        <el-button type="text" style="color:gray" size="small" @click.native="ConnectExamine(scope.row.id,scope.row.is_release,scope.row.is_fold,'is_fold')" ><span :class="scope.row.is_fold===1?'activeColor':''">折叠</span></el-button>
                        <el-button type="text" style="color:gray" size="small" @click.native="ConnectExamine(scope.row.id,scope.row.is_release,scope.row.is_abbreviate,'is_abbreviate')" ><span :class="scope.row.is_abbreviate===1?'activeColor':''">缩略</span></el-button>
                    </span>
                    
                </template>
            </el-table-column>
        </el-table>

        <el-pagination class="pagination-container"
            style="height:50px;"
            background
            :page-size="page_size"            
            @current-change="handleCurrentChange"
            layout="total,prev, pager, next"
            :total="total"
            :current-page.sync="query.page">
        </el-pagination>

    </div>

</template>

<script>
import { cateExamineCommentList, ContentExamine, userSaveExamine } from "../../api/category/category";
export default {
    data() {
        return {
            loading: true,
            searchUsersType: "id",
            total: 0,
            page_size: 10,
            currentPage: 1,
            query: {
                page:'1',
                find_id: ''
            },
            datass: [],
            multipleSelection:[],
            switchData: [],
            activeIndex:'',
            new_state: '',
            examineDataTo: [],
            is_release_type: '',
        };
    },
    methods: {
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleSizeChange(val) {
            this.query.limit = val;
            this.getData();
        },
        handleCurrentChange(val) {
            this.query.page = val;
            sessionStorage.setItem( "currentPage_findList", val);
            // scrollTo(0, 800);
            this.getData();
        },
        getData() {
            this.query.page = 1;
            cateExamineCommentList(this.query).then(response => {
                this.datass = response.data.data || [];
                this.loading = false;
                this.total = response.data.total;
            }).catch(() => {
                this.loading = false;
                this.datass = [];
                this.total = 0;
            });
        },
        // 用户放行
        Examine(user_id,state){
            this.examineDataTo = {'user_id':user_id,'is_examine':state};
            userSaveExamine(this.examineDataTo)
                .then(response => {
                    if (response.code != 0) {
                        this.$message.error(response.msg);
                        return false;
                    } else {
                        this.$message.success("success");
                        this.getData();
                    }
                })
                .catch(() => {
                    this.deleteLoading = false;
                });
        },
        // 观点审核操作
        ConnectExamine(id,is_release_status,state,type) {
            if (state ==1) this.new_state = 2
            if (state ==2) this.new_state = 1
            var state = !state
            this.examineData = {'id':id,'state':this.new_state,'type':type};
            ContentExamine(this.examineData)
                .then(response => {
                    if (response.code != 0) {
                        this.$message.error(response.msg);
                        return false;
                    } else {
                        this.$message.success("success");
                        this.getData();
                    }
                })
                .catch(() => {
                    this.deleteLoading = false;
                });
        },
        onSubmit(type) {
            // this.query.page = 1;
            if (type == 1) {
                this.getData();
            }
            if (type == 2) {
                this.currentPage = 1;
                this.query = {
                    page: 1,
                    id: "",
                    mobile: "",
                    name: "",
                    token: 1111,
                    user_id: 1,
                    limit: 10,
                    start_time: "",
                    end_time: "",
                    status:1,
                    user_type:2,
                    find_type:3
                };
                this.getData();
            }
        },
        // 开关操作
        changeSwitch (index,cate_id,is_sign) {
            this.switchData = {'cate_id':cate_id,'is_sign':is_sign};
            switchChange(this.switchData)
                .then(response => {
                    if (response.code != 0) {
                        this.$message.error(response.msg);
                        return false;
                    } else {
                        if (is_sign == 1) {
                            this.$message.success("已开启观点显示");
                            this.data.splice(index, 1);
                            this.getData();
                        } else {
                            this.$message.success("已关闭观点显示");
                            this.data.splice(index, 1);
                            this.getData();
                        }
                        
                    }
                })
                .catch(() => {
                    this.deleteLoading = false;
                });
        },
        // 恢复操作
        handleDel(index, row) {
            if (row) {
                this.$confirm("确认恢复该记录吗?", "提示", {
                    type: "warning"
                })
                .then(() => {
                    let para = { find_id: row };
                    this.deleteLoading = true;
                    recycleRecovery(para)
                        .then(response => {
                            this.deleteLoading = false;
                            if (response.code != 0) {
                                this.$message.error(response.msg);
                                return false;
                            } else {
                                this.$message.success("恢复成功");
                                this.data.splice(index, 1);
                                this.getData();
                            }
                        })
                        .catch(() => {
                            this.deleteLoading = false;
                        });
                })
                .catch(() => {
                    this.$message.info("取消删除");
                });
            }
        },
        // 审核
        handleCheck(index,row, status) {
            if (row) {
                var tishi = '';
                if(status == 2) {
                    tishi = '拒绝';
                } else {
                    tishi = '通过';
                }
                this.$confirm("确认" + tishi +"该记录吗?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        let para = { find_id: row , status:status};
                        this.deleteLoading = true;
                        findCheck(para)
                            .then(response => {
                                this.deleteLoading = false;
                                if (response.code != 200) {
                                    this.$message.error(response.message);
                                    return false;
                                }
                                this.$message.success(tishi+"成功");
                                // 刷新数据
                                this.data.splice(index, 1);
                                this.getData();
                            })
                            .catch(() => {
                                this.deleteLoading = false;
                            });
                    })
                    .catch(() => {
                        this.$message.info("取消删除");
                    });
            }
        },
        handleForm(index,row) {
            this.$router.push({
                path: "/posting/postingDetail",
                query: {
                    find_id: row
                }
            });
        },
        // 显示表单
        handleForm2(index,row) {
            this.$router.push({
                path: "/posting/postingComment",
                query: {
                    find_id: row
                }
            });
        }
    },
    // watch:{   //watch()监听某个值（双向绑定）的变化，从而达到change事件监听的效果
    //     datass:{
    //         handler:function(){
    //            this.getData();
    //         //    this.ConnectExamine()
    //         },
    //         deep:true
    //     }
    // },
    // watch:{
    //     datass:function(){
    //         this.$nextTick(function(){
    //             this.getData()

    //         })
    //     }
    // },
    filters: {
        ellipsis (value) {
            if (!value) return ''
            if (value.length > 18) {
                return value.slice(0,18) + '...'
            }
            return value
        },
        topStatus(status) {
            const statusMap = {
                1: "置顶",
                2: "取消置顶"
            };
            return statusMap[status];
        },
        statusFilterType(status) {
            const statusMap = {
                0: "gray",
                1: "success"
            };
            return statusMap[status];
        },
        statusFilterName(status) {
            const statusMap = {
                1: "普通用户",
                2: "医生",
                3: "咨询师",
                4: "医院",
                5: "未确定"
            };
            return statusMap[status];
        }
    },
    mounted() {},
    created() {
        this.query.find_id = this.$route.params.find_id ?  this.$route.params.find_id : 0 ;
        this.query.page = Number(sessionStorage.getItem("currentPage_findList")) || 1;
        this.getData();
    }
};
</script>
<style type="text/scss" lang="scss">
</style>
<style>
 .el-form-item__label{
     margin-top: 5px;
     color: rgb(236, 150, 45)
 }
 .activeColor{
     color:rgb(129, 221, 68);
 }
 button{
     color:gray;
 }
</style>
